import {
  createKeyRequest,
  getAllEvent,
  getAllRoomBooking,
  getSingleKeyRequest,
  handleKeyDown,
  updateKeyRequest,
} from "_services";
import { checkRoom, checkWhatsapp } from "_services/guestServices";
import { CommonInput, CustomSelect, Heading } from "components";
import { BasicExample } from "components/common/CommonModal/CommonModal";
import { Images } from "constants";
import { errorSchema, utils } from "helper";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const CreateKeyRequest = () => {
  const initi = {
    event: "",
    room: "",
    room:"",
    room_booking:"",
    guest_name: "",
    mobile_number: "",
    reason: "",
    verification_code: "",
    is_verified: false,
  };

  const eventRef = useRef(null);
  const roomRef = useRef(null);
  const mobileRef = useRef(null);
  const nameRef = useRef(null);
  const resonRef = useRef(null);
  const navigate = useNavigate();
  const { id, eventView } = useParams();
  const [form, setForm] = useState(initi);
  const [initialForm, setInitialForm] = useState(initi);
  const [formError, setFormError] = useState("");
  const [allEventList, setAllEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allRoomlist, setAllRoomList] = useState([]);
  const [idVerify, setIdVrify] = useState(id);
  const [checkRoomAvailable, setCheckRoomAvailable] = useState("");
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [checkAvailable, setCheckAvailable] = useState("");

  const reasonList = [
    { label: "KEY LOST", value: 1 },
    { label: "LOCKER UNLOCK REQUEST", value: 2 },
    { label: "MASTER KEY ACCESS", value: 3 },
  ];

  useEffect(() => {
    if (roomRef.current) {
      roomRef.current.focus();
    }
  }, []);

  useEffect(() => {
    getEventList(id);
  }, []);

  useEffect(() => {
    if (id) {
      getKeyRequestDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (form?.mobile_number && form.mobile_number.length === 10) {
      getWhatsappAbility(form?.mobile_number);
    } else {
      setCheckAvailable("false");
    }
  }, [form?.mobile_number]);

  useEffect(() => {

      if (
        form?.room &&
        form.room.length === 3 &&
        !["175", "141", "125", "109", "209", "158", "192"].includes(
          form.room
        )
      ) {
        getRoomAbility(form?.room);
      } else {
        setAllRoomList("")
        setCheckRoomAvailable("false");
       
      }

  }, [form?.room]);

  const getWhatsappAbility = async (mobile) => {
    try {
      setLoadingCheck(true);
      const res = await checkWhatsapp({ mobile_number: mobile });
      if (res?.status === 200) {
        setCheckAvailable(res?.results?.is_whatsapp_number ? "yes" : "no");
      }
      setLoadingCheck(false);
    } catch (error) {
      setLoadingCheck(false);
    }
  };

  const getRoomBookingList = async (event_id, room_id) => {
    try {
      const res = await getAllRoomBooking({
        event_id: Number(event_id),
        room_number: Number(form?.room),
      });

      if (res?.status === 200) {
        setAllRoomList(res.results[0]);
        if (res.results.length) {
          setForm((pre) => ({
            ...pre,
            guest_name: res.results[0]?.guest_details?.name,
            mobile_number: res.results[0]?.guest_details?.mobile_number,
            room_booking:res?.results[0]?.id
          }));
        } else {
          setForm((pre) => ({ ...pre, guest_name: "", mobile_number: "" }));
        }
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getEventList = async (id) => {
    try {
      const res = await getAllEvent({ limit: "all" });

      if (res?.status === 200) {
        const filterEvent = res.results?.find((i) => i?.is_active === true);
        setAllEventList([
          {
            ...filterEvent,
            label: filterEvent?.event_name,
            value: filterEvent?.value,
          },
        ]);
        if (!id) {
          setForm({ ...form, event: filterEvent?.id });
        }
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getRoomAbility = async (room) => {
    try {
      setLoadingCheck(true);
      const res = await checkRoom(room);
      if (res?.status === 200) {
        setCheckRoomAvailable(res?.results?.is_booked == false ? "yes" : "no");
  
        getRoomBookingList(form?.event, res?.results?.room_id);
      } else {
      }
      setLoadingCheck(false);
    } catch (error) {}
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
              checkRoomAvailable: checkRoomAvailable,
            },
            errorSchema.keyRequestSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const getKeyRequestDetails = async (id) => {
    try {
      const res = await getSingleKeyRequest(id);

      if (res?.status === 200) {
        setForm((pre) => ({
          ...pre,
          event: res?.results.event ? res?.results?.event : "",
          room: res?.results.room_number
            ? String(res?.results?.room_number)
            : "",
          guest_name: res?.results.guest_name ? res?.results?.guest_name : "",
          mobile_number: res?.results.mobile_number
            ? res?.results?.mobile_number
            : "",
          reason: res?.results.reason ? res?.results?.reason : "",
          verification_code: res?.results.verification_code
            ? res?.results?.verification_code
            : "",
          is_verified: res?.results.is_verified,
        }));
        setIdVrify(res?.results?.id);
      }
    } catch (error) {}
  };



  const createPayload = () => {
    const allowedKeys = ["room_booking", "event", "reason"];
    return allowedKeys.reduce((acc, key) => {
      if (form[key] !== initialForm[key]) {
        acc[key] = key === "room_booking" ? Number(form[key]) : form[key];
      }
      return acc;
    }, {});
  };

  const handleKeyRequest = async () => {
    const validationResult = await utils?.checkFormError(
      { ...form, checkout: allRoomlist?.check_out?"no":"yes" },
      errorSchema.keyRequestSchema
    );

    if (validationResult === true) {
      setIsLoading(true);
      try {
        let res;
        const payload = createPayload();

        if (id) {
          res = await updateKeyRequest({ payload, id });
        } else {
          res = await createKeyRequest(payload);
        }

        if (res.status === 200 || res.status === 201) {
          navigate("/keyrequest");
          toast.success(res.message);
          setForm({
            ...form,
            verification_code: res.results.verification_code,
            is_verified: res.results.is_verified,
          });
          setIdVrify(res.results.id);
        } else {
          toast.error(res.error);
        }
      } catch (error) {
        toast.error("An error occurred");
      } finally {
        setIsLoading(false);
      }
    } else {
      setFormError(validationResult);
    }
  };
  const updateVerification = async (idVerify) => {
    const payload = {
      is_verified: !form?.is_verified,
    };

    try {
      const res = await updateKeyRequest({
        payload,
        id: idVerify,
      });

      if (res.status === 200) {
        setIsLoading(false);
        toast.success(res.message);
        setForm({
          ...form,
          is_verified: res?.results?.is_verified,
        });
      } else {
        setForm({
          ...form,
          is_verified: false,
        });
        toast.error(res.error);
      }
    } catch (error) {}
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef) {
        nextInputRef.current.focus();
      } else {
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  return (
    <div>
      <Heading title={"Add Key Request"} />
      <div className="_addContainer bg-[#FBF9FB]">
        <div className="_midCont_body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-10 col-xl-8">
                <div className="_crtDisp_listBx">
                  <div className="">
                    <h4 className="_disPatch_heads">Event Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divsix">
                        <div className="singleDiv">
                          <CustomSelect
                            placeholder="Select Event"
                            label="Event"
                            options={allEventList}
                            onSelect={(data) => {
                              handleOnChange("event", data.value);
                            }}
                            focus={
                              !!(
                                typeof formError === "object" &&
                                formError?.event
                              )
                            }
                            error={
                              !!(typeof formError === "object")
                                ? formError?.event
                                : ""
                            }
                            value={allEventList?.find(
                              (i) => i?.id === form?.event
                            )}
                            disabled={true}
                            ref={eventRef}
                            enableSearch={true}
                            onEnterSelect={() => mobileRef.current.focus()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <h4 className="_disPatch_heads">Room Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divsix">
                        <CommonInput
                          type="text"
                          placeholder=""
                          label="Room"
                          name="room"
                          value={form.room}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.room
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.room
                              : ""
                          }
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                          ref={roomRef}
                          // onKeyDown={(e) => handleKey(e, nameRef)}
                          disabled={eventView}
                          onKeyPress={handleKeyDown}
                          borderStyle={checkRoomAvailable}
                          // whatsAbility={true}
                          abilityTitle="Available"
                          maxLength={3}
                        />
                      </div>
                      {/* <div className="_divsix">
                        <CommonInput
                          type="text"
                          label="Name"
                          placeholder="Enter Name"
                          name="guest_name"
                          value={form?.guest_name}
                          onChange={({ target: { name, value } }) => {
                            handleOnChange(name, value);
                          }}
                          focus={!!formError?.guest_name}
                          error={formError.guest_name}
                          ref={nameRef}
                          onKeyDown={(e) => handleKey(e, mobileRef)}
                          disabled={eventView}
                        />
                      </div> */}
                      {/* <div className="_divsix">
                        <CommonInput
                          type="text"
                          label="Mobile"
                          placeholder="Enter Mobile Number"
                          name="mobile_number"
                          value={form?.mobile_number}
                          onChange={({ target: { name, value } }) => {
                            handleOnChange(name, value);
                          }}
                          focus={!!formError?.mobile_number}
                          error={formError.mobile_number}
                          ref={mobileRef}
                          onKeyDown={(e) => handleKey(e, resonRef)}
                          disabled={eventView}
                          onKeyPress={handleKeyDown}
                          maxLength={10}
                          borderStyle={checkAvailable}
                          whatsAbility={true}
                          helpText="Mobile Number Without +91"
                          abilityTitle="Whatsapp"
                        />
                      </div> */}
                      <div className="_divsix">
                        <CustomSelect
                          placeholder="Select Reason"
                          label="Reason"
                          options={reasonList}
                          onSelect={(data) => {
                            handleOnChange("reason", data.value);
                          }}
                          focus={
                            !!(
                              typeof formError === "object" && formError?.reason
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.reason
                              : ""
                          }
                          value={reasonList?.find(
                            (i) => i?.value === form?.reason
                          )}
                          disabled={eventView}
                          ref={resonRef}
                          enableSearch={true}
                          // onEnterSelect={() => mobileRef.current.focus()}
                        />
                      </div>
                      {/* {form?.guest_name && form?.mobile_number.length == 10 && ( */}
                        <>
                          {form?.room.length==3 && (
                            <div className="_divsix" style={{marginTop:10}} >
                             
                                <button
                                  className="_addComm_btn"
                                  type="button"
                                  onClick={() => handleKeyRequest()}
                                  disabled={isLoading}
                                >
                                  {isLoading ? (
                                    <BasicExample />
                                  ) : (
                                    "Create Key Request"
                                  )}
                                </button>
                           
                            </div>
                          )}
                        </>
                      {/* )} */}
                    </div>
                  </div>
                  {/* {form?.verification_code && (
                    <div className="">
                      <h4 className="_disPatch_heads">Verification Details</h4>
                      <div className="_fleX_inds">
                        <div className="_divsix">
                          <div className="singleDiv">
                            <CommonInput
                              type="text"
                              label="verification Code"
                              name="reason"
                              value={form?.verification_code}
                              onChange={({ target: { name, value } }) => {
                                handleOnChange(name, value);
                              }}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="_divsix">
                          <div
                            className="_anvSwitcherNew form-check form-switch"
                            style={{ width: "100%" }}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="actStatus"
                              id={`actStatus-${form?.is_verified}`}
                              autoComplete="off"
                              checked={form?.is_verified}
                              onChange={() => {
                                setForm((pre) => ({
                                  ...pre,
                                  is_verified: !form?.is_verified,
                                }));
                                updateVerification(idVerify);
                              }}
                              readOnly
                              // disabled={form?.is_verified}
                            />
                            <span
                              className={
                                form?.is_verified
                                  ? "active_label_masters_status"
                                  : "disabled_label_masters_status"
                              }
                            >
                              {form?.is_verified ? "Verified" : "Not Verified"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
              {loadingCheck && (
                <div className="loading-overlay">
                  <img
                    src={Images?.HOTALLOADER}
                    alt="Loading..."
                    className="loader-gif"
                  />
                </div>
              )}
              {allRoomlist && <EventCard data={allRoomlist} />}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="bottomFix">
        <button
          className="_addComm_btn"
          type="button"
          onClick={() => handleSubmit()}
          disabled={isLoading}
        >
          {isLoading ? <BasicExample /> : "Add Key Request"}
        </button>
      </div> */}
    </div>
  );
};

export default CreateKeyRequest;

const EventCard = ({ data }) => {
  const styles = {
    card: {
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "16px",
      maxWidth: "400px",
      margin: "20px 10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    title: {
      fontSize: "20px",
      marginBottom: "8px",
    },
    subtitle: {
      fontSize: "16px",
      color: "#555",
      marginBottom: "16px",
    },
    section: {
      marginBottom: "16px",
    },
  };

  const {
    event_name,
    check_in,
    check_out,
    total_guests,
    special_requests,
    floor_name,
    room_number,
    guest_details,
  } = data;

  return (
    <div style={styles.card}>
      <h2 style={styles.title}>{event_name}</h2>
      <p style={styles.subtitle}>
        Room {room_number} - {floor_name}
      </p>

      <div style={styles.section}>
        <h3>Guest Information</h3>
        <p>
          <strong>Name:</strong> {guest_details?.name}
        </p>
        
        <p>
          <strong>Mobile:</strong> {guest_details?.mobile_number}
        </p>
        
       
      </div>

      <div style={styles.section}>
        <h3>Booking Details</h3>
        <p>
          <strong>Check-In:</strong> {new Date(check_in).toLocaleString()}
        </p>
        <p>
          <strong>Check-Out:</strong>{" "}
          {check_out ? new Date(check_out).toLocaleString() : "N/A"}
        </p>
        <p>
          <strong>Total Guests:</strong> {total_guests}
        </p>
     
      </div>
    </div>
  );
};
